import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import {SendNotificationProvider} from "../../contexts/notification/SendNotificationContext";
import {ProductDetailProvider} from "../../contexts/productContext/ProductDetailContext";

const NotificationFragment = Loadable(lazy(() => import('./views/NotificationFragment')));
const NewNotificationFragment = Loadable(lazy(() => import('./views/NewNotificationFragment')));
const NotificationCampaignDetails = Loadable(lazy(() => import('./views/NotificationCampaignDetails')));
const SendProductNotification = Loadable(lazy(() => import('./views/SendProductNotification')));

const notificationRoutes = [
    { path: '/notifications', element: <SendNotificationProvider><NotificationFragment /></SendNotificationProvider> },
    { path: '/notifications-campaign', element: <div><NewNotificationFragment /></div> },
    { path: '/notifications-campaign/campaign-details/:id', element: <div><NotificationCampaignDetails /></div> },
    { path: '/product_notification/:id', element: <ProductDetailProvider><SendNotificationProvider><SendProductNotification /></SendNotificationProvider></ProductDetailProvider> },
];

export default notificationRoutes;
